import React from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import City from "../../city.json";

const PartyModal = ({
  show,
  onClose,
  party,
  setParty,
  selectedState,
  setSelectedState,
  selectedCity,
  setSelectedCity,
  error,
  onSubmit,
  disableSubmit,
}) => {
  const groupData = useSelector((state) => state?.getPartyGroup?.user?.data) || [];
  const tagData = useSelector((state) => state?.getPartyTag?.user?.data) || [];

  const defaultCountry = City.find((c) => c.iso2 === "IN");
  const states = defaultCountry ? defaultCountry.states : [];
  const cities = states.find((s) => s.name === selectedState)?.cities || [];

  React.useEffect(() => {
    if (tagData?.length > 0 && !party.party_tag) {
      const partyTag = tagData.find((tag) => tag.name?.toLowerCase() === "party");
      if (partyTag) {
        setParty("party_tag", partyTag._id);
      }
    }
  }, [tagData, party.party_tag, setParty]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "pincode") {
      setParty(name, value.replace(/\D/g, "").slice(0, 6));
      return;
    }
    setParty(name, value);
  };

  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Add Party</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="input-block local-forms">
              <label>Name <span className="login-danger">*</span></label>
              <input
                className="form-control"
                type="text"
                name="name"
                value={party.name}
                onChange={handleChange}
                placeholder="Enter name"
              />
              {error?.name_err && <div className="error text-danger mt-1">{error.name_err}</div>}
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="input-block local-forms">
              <label>Mobile <span className="login-danger">*</span></label>
              <input
                className="form-control"
                type="number"
                name="phone"
                value={party.phone}
                onChange={handleChange}
                placeholder="Enter mobile"
                onWheel={(e) => e.target.blur()}
              />
              {error?.phone_err && <div className="error text-danger mt-1">{error.phone_err}</div>}
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="input-block local-forms">
              <label>Address <span className="login-danger">*</span></label>
              <input
                className="form-control"
                type="text"
                name="address"
                value={party.address}
                onChange={handleChange}
                placeholder="Enter address"
              />
              {error?.address_err && <div className="error text-danger mt-1">{error.address_err}</div>}
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="input-block local-forms">
              <label>State <span className="login-danger">*</span></label>
              <select
                className="form-control select"
                value={selectedState}
                onChange={(e) => { setSelectedState(e.target.value); setSelectedCity(""); }}
              >
                <option value="">Select State</option>
                {states.map((s) => (
                  <option key={s.name} value={s.name}>{s.name}</option>
                ))}
              </select>
              {error?.state_err && <div className="error text-danger mt-1">{error.state_err}</div>}
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="input-block local-forms">
              <label>City <span className="login-danger">*</span></label>
              <select
                className="form-control select"
                value={selectedCity}
                onChange={(e) => setSelectedCity(e.target.value)}
                disabled={!selectedState}
              >
                <option value="">Select City</option>
                {cities.map((c) => (
                  <option key={c.id} value={c.name}>{c.name}</option>
                ))}
              </select>
              {error?.city_err && <div className="error text-danger mt-1">{error.city_err}</div>}
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="input-block local-forms">
              <label>Pincode <span className="login-danger">*</span></label>
              <input
                className="form-control"
                type="text"
                name="pincode"
                value={party.pincode}
                onChange={handleChange}
                placeholder="Enter pincode"
                maxLength={6}
              />
              {error?.pincode_err && <div className="error text-danger mt-1">{error.pincode_err}</div>}
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="input-block local-forms">
              <label>Group <span className="login-danger">*</span></label>
              <select
                className="form-select"
                name="group"
                value={party.group}
                onChange={handleChange}
              >
                <option value="">Select Group</option>
                {groupData.map((e) => (
                  <option key={e._id} value={e._id}>{e.name}</option>
                ))}
              </select>
              {error?.group_err && <div className="error text-danger mt-1">{error.group_err}</div>}
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="input-block local-forms">
              <label>Tag <span className="login-danger">*</span></label>
              <select
                className="form-select"
                name="party_tag"
                value={party.party_tag}
                onChange={handleChange}
              >
                <option value="">Select Tag</option>
                {tagData.map((e) => (
                  <option key={e._id} value={e._id}>{e.name}</option>
                ))}
              </select>
              {error?.party_tag_err && <div className="error text-danger mt-1">{error.party_tag_err}</div>}
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onSubmit}
          disabled={disableSubmit}
        >
          {disableSubmit ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PartyModal;
